// extracted by mini-css-extract-plugin
export default {"cell":"expand-cell-module__cell--AIEWa"};